module.exports = __webpack_public_path__ + "static/img/no-status.25f4f91e.png";